<template>
    <div :key="render" class="viewport">
        <md-toolbar :md-elevation="1">
            <router-link :to="{ path: 'filtering', query: { station: station } }">
                <div class="md-headline" style="display: flex; align-items: center">
                    <img
                        v-if="!current_location.finish"
                        :src="$store.state.publicPath + 'only_cam_white.png'"
                        class="logo_top mouse_over_off"
                        style="height: 60px"
                    />
                    <img
                        v-else
                        :src="$store.state.publicPath + 'only_cam_disabled_white.png'"
                        class="logo_top mouse_over"
                        style="height: 60px; opacity: 0.5"
                    />
                    <span v-if="current_location.finish" style="color: #b6b6b699 !important"
                        >{{ title }} ({{ $t('from') }} {{ current_location.deployment }}
                        {{ $t('until') }} {{ current_location.finish }})
                    </span>
                    <span v-else style="color: #2dc6d6 !important">
                        {{ title }}
                        ({{ $t('from') }} {{ current_location.deployment }} {{ $t('until now') }})
                    </span>
                </div>
            </router-link>
        </md-toolbar>
        <div style="padding: 20px">
            <div
                v-for="(group, index) in cameras"
                :key="index + '_cam'"
                class="md-layout"
                style="margin-bottom: 30px; text-align: center"
            >
                <!-- {{get_group("clm")}}<br/>{{group}}{{index}} -->
                <div class="md-layout-item md-size-100">
                    <router-link
                        :to="{
                            path: 'filtering',
                            query: { station: station, group: group[0].cam_group }
                        }"
                    >
                        <span
                            v-if="current_location.finish"
                            style="color: #b6b6b6; font-size: 125%"
                        >
                            <md-icon style="margin-right: 5px; color: #b6b6b6">wifi_off</md-icon>
                            {{ $t('Group') }}:<b>{{ group[0].cam_group.toUpperCase() }}</b> ({{
                                $t('from')
                            }}
                            {{ get_group(group[0].cam_group).deployment }} {{ $t('until') }}
                            {{ get_group(group[0].cam_group).finish }})
                        </span>
                        <span v-else style="font-size: 125%">
                            <md-icon style="margin-right: 5px; color: #2dc6d6 !important"
                                >wifi</md-icon
                            >{{ title }} {{ $t('Group') }}:<b>{{
                                group[0].cam_group.toUpperCase()
                            }}</b>
                            ({{ $t('from') }} {{ get_group(group[0].cam_group).deployment }}
                            {{ $t('until now') }})
                        </span>
                    </router-link>
                </div>
                <div
                    v-for="(camera, index) in group"
                    :key="index + '_group'"
                    class="md-layout-item md-xsmall-size-100"
                    style="min-width: 250px; max-width: 500px; margin: auto"
                >
                    <md-card>
                        <md-card-area md-inset>
                            <md-card-content v-if="camera.last_modified && show_date">
                                <h6
                                    >{{ camera.last_modified.split('T')[0] }}
                                    {{ camera.last_modified.split('T')[1].split('+')[0] }}</h6
                                >
                            </md-card-content>
                            <md-card-media>
                                <img
                                    :src="$store.state.base_url + camera.url"
                                    @click="show_image(camera, $store.state.base_url + camera.url)"
                                />
                            </md-card-media>

                            <md-card-header v-if="show_text">
                                <h2 class="md-title">
                                    <router-link
                                        :to="{
                                            path: 'filtering',
                                            query: {
                                                station: station,
                                                group: group[0].cam_group,
                                                cameras: camera.cam,
                                                product: 'snapshot'
                                            }
                                        }"
                                    >
                                        <img
                                            v-if="!current_location.finish"
                                            :src="$store.state.publicPath + 'only_cam.png'"
                                            class="logo_top mouse_over"
                                            style="
                                                float: left;
                                                height: 50px;
                                                margin: 10px;
                                                margin-top: -5px;
                                            "
                                        />
                                        <img
                                            v-else
                                            :src="
                                                $store.state.publicPath +
                                                'only_cam_disabled_white.png'
                                            "
                                            class="logo_top mouse_over"
                                            style="
                                                float: left;
                                                height: 50px;
                                                margin: 10px;
                                                margin-top: -5px;
                                                opacity: 0.5;
                                            "
                                        />
                                        <span style="float: left">{{ camera.cam }} </span>
                                    </router-link>
                                    <md-button
                                        class="md-primary"
                                        @click="
                                            show_image(camera, $store.state.base_url + camera.url)
                                        "
                                        style="float: right"
                                        ><md-icon>fullscreen</md-icon></md-button
                                    >
                                    <div style="clear: both"></div>
                                </h2>
                            </md-card-header>
                        </md-card-area>
                    </md-card>
                </div>
                <md-divider></md-divider>
            </div>
        </div>
        <md-dialog :md-active.sync="showDialog">
            <md-dialog-title>{{ title }} {{ $t('Camera') }} {{ dialog_camera }}</md-dialog-title>
            <md-dialog-content>
                <img v-show="img_load" :src="url_image" @load="img_load = true" />
                <img v-show="!img_load" :src="$store.state.publicPath + 'loading.gif'" />
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="showDialog = false">{{
                    $t('Close')
                }}</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'last-images',
    props: {
        title: {
            type: String,
            default: 'Latest images'
        },
        station: {
            type: String,
            default: 'clm'
        },
        groups: {
            type: String,
            default: 'clm'
        },
        show_text: {
            type: Boolean,
            default: true
        },
        show_date: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            cams: {},
            render: 0,
            showDialog: false,
            url_image: '',
            dialog_camera: '',
            img_load: false
        }
    },
    computed: {
        current_location() {
            if (this.station != '') return this.$store.getters.getLocationByCode(this.station)
            else return {}
        },
        cameras() {
            return this.cams
        },
        _groups() {
            return this.groups.split(',')
        }
    },
    watch: {
        cameras() {
            this.update_images()
        }
    },
    mounted() {
        this.update_images()
    },
    methods: {
        get_group(group_code) {
            return this.$store.getters.getGroupByCode(this.station, group_code)
        },
        show_image(camera, url) {
            this.img_load = false
            this.url_image = url.replace('thumbnail/', '')
            this.showDialog = true
            this.dialog_camera = camera.cam
        },
        update_images() {
            var base_url = this.$store.state.base_url + '/api/image_access/getlatestdirectory/'
            for (var index in this._groups) {
                axios
                    .get(base_url + this.station + '/' + this._groups[index] + '/thumbnail/')
                    .then((response) => {
                        this.cams[response.config.url] = response.data.cameras
                        this.render += 1
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        }
    },
    beforeDestroy() {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
.popup,
.leaflet-popup-content {
    width: 400px !important;
}
.popup .title {
    background-color: #1f8d98;
    color: white;
    font-size: 150%;
    padding: 10px;
}
.infocontent {
    background-color: white;
    color: #132b3f;
    font-size: 125%;
    padding: 20px;
}
.leaflet-popup-content-wrapper {
    background-color: #132b3f !important;
}
.logo_top {
    float: left;
    vertical-align: middle;
    margin: 10px;
    margin-right: 40px;
}
.mouse_over:hover {
    opacity: 1 !important;
}
.mouse_over_off:hover {
    opacity: 0.5 !important;
}
</style>
